import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const timetable: ApiFunc<`${typeof API.TIMETABLE}`, 'get'> = data =>
  instance.get(API.TIMETABLE, { params: data })

export const timetableAll: ApiFunc<`${typeof API.TIMETABLE_ALL}`, 'get'> = data =>
  instance.get(API.TIMETABLE_ALL, { params: data })

export const timetableGenerate: ApiFunc<`${typeof API.TIMETABLE_GENERATE}`, 'post'> = data =>
  instance.post(API.TIMETABLE_GENERATE, data)
